import { io, Socket as BaseSocket } from "socket.io-client";

export const createSocket = (token: string): Socket => {
  const socket = io({
    path: "/msg",
    auth: {
      token
    }
  });

  const emitPromise = (...args: Parameters<BaseSocket["emit"]>) => {
    return new Promise<string>((res) => {
      const ack = res;
      args.push(ack);
      console.log("Calling emit!", args);
      socket.emit(...args);
    });
  };

  Object.assign(socket, { emitPromise });

  return new Proxy(socket, {
    get(target, prop) {
      const method = (target as any)[prop];
      if (typeof method === "function" && prop === "emit") {
        return (...args: any[]) => {
          const eventName = args[0];
          console.log("Emitting", { eventName, args });
          return method.apply(target, args);
        };
      }
      return method;
    }
  }) as Socket;
};

export type Socket = BaseSocket & {
  emitPromise: (...args: Parameters<BaseSocket["emit"]>) => Promise<string>;
};
